import { bindContactClicks, exposeTextMaps, gaMeasurementId, initAnalytics, initLightbox } from './siteChrome';

// Loaded by _LayoutFrontend.cshtml on every public page, BEFORE the deferred site scripts and the
// other page modules (scripts run in document order), so window.feText / pfText exist when they read them.
exposeTextMaps(window, document);

const gaId = gaMeasurementId(document);
if (gaId) {
    initAnalytics(window, gaId);
    bindContactClicks(document, name => (window as any).gtag('event', name));
}

// GLightbox is a deferred classic script that runs after this module; DOMContentLoaded fires after it.
document.addEventListener('DOMContentLoaded', () => initLightbox(window, document));
